export enum ModalType {
    produttore,
    prodotto,
    categoria,
    articolo
}
